/*
 * @Author: your name
 * @Date: 2021-01-08 21:09:07
 * @LastEditTime: 2021-01-13 15:04:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /java-pc/src/utils/config.js
 */
/**
 *  项目的配置文件
 */
// export const apiUrl =  'https://jbbcdev.slodon.cn/';//接口请求地址
//export const apiUrl = 'https://jbbc.slodon.cn';
export const apiUrl = 'http://www.escmf.com';
// export const apiUrl = 'http://localhost:8001';
export const curLang = 'zh';//当前语言,zh:中文，若为其他语言，需要对应/src/assets/language下面的文件名